import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { render } from 'preact';
import { useState, useEffect } from 'preact/hooks';
const GlobalErrorModal = ({ message }) => {
    useEffect(() => {
        setIsOpen(typeof message === 'string');
    }, [message]);
    const [isOpen, setIsOpen] = useState(false);
    const handleClose = () => {
        setIsOpen(false);
    };
    return (_jsxs("div", Object.assign({ className: `modal is-clipped ${isOpen ? 'is-active' : ''}`, onClick: handleClose }, { children: [_jsx("div", { className: 'modal-background', onClick: handleClose }, void 0),
            _jsx("div", Object.assign({ className: 'modal-content no-style' }, { children: _jsxs("div", Object.assign({ className: 'notification' }, { children: [_jsx("h3", Object.assign({ className: 'is-size-4 has-text-centered' }, { children: "\u30A8\u30E9\u30FC\u30E1\u30C3\u30BB\u30FC\u30B8" }), void 0),
                        _jsx("div", Object.assign({ className: 'my4 is-size-4 error' }, { children: _jsx("ul", { children: message.split(/\n/).map((msg, index) => (_jsxs("ol", { children: ["\u30FB", msg] }, index))) }, void 0) }), void 0)] }), void 0) }), void 0)] }), void 0));
};
window.addEventListener('load', () => {
    const root = document.querySelector('#GlobalErrorModal');
    if (root) {
        const message = root.getAttribute('data-message');
        if (!message) {
            return;
        }
        render(_jsx(GlobalErrorModal, { message: message }, void 0), root);
    }
});
